// Overpass queries for a 2·half metre box — pure, shared by the browser loader and the Worker proxy.
export const OVERPASS_ENDPOINTS = [
  'https://overpass-api.de/api/interpreter',
  'https://overpass.kumi.systems/api/interpreter',
  'https://maps.mail.ru/osm/tools/overpass/api/interpreter',
  'https://overpass.private.coffee/api/interpreter',
];
export function bbox(lat: number, lon: number, half: number){
  const dLat = half / 111320, dLon = half / (111320 * Math.cos(lat * Math.PI / 180));
  return `${lat - dLat},${lon - dLon},${lat + dLat},${lon + dLon}`;
}
export function overpassQuery(lat: number, lon: number, half: number){
  const b = bbox(lat, lon, half);
  return `[out:json][timeout:40];(way["building"](${b});way["highway"~"^(motorway|trunk|primary|secondary|tertiary|residential|unclassified|living_street|pedestrian|motorway_link|primary_link)$"](${b});way["leisure"~"^(park|garden|pitch)$"](${b});way["landuse"="grass"](${b});way["natural"~"^(water|coastline)$"](${b});way["waterway"="riverbank"](${b});relation["natural"="water"](${b});relation["waterway"="riverbank"](${b});relation["leisure"="park"](${b}););out body;>;out skel qt;`;
}
export function countQuery(lat: number, lon: number, half: number){
  return `[out:json][timeout:15];way["building"](${bbox(lat, lon, half)});out count;`;
}
export const MIN_BUILDINGS = 8;   // fewer mapped buildings than this and there is no game in the box
